/// <amd-module name="Work/Views/MyWork/DataProviders/MyWorkAssignedToMeDataProvider" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { WorkItem, AccountMyWorkResult, AccountWorkWorkItemModel } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import * as ContributionRoutes from "../Constants/ContributionRoutes";
import * as MyWorkResources from "Work/Views/MyWork/Resources";
import { routeUrl } from "VSS/Platform/Location";
import { format, dateToString } from "VSS/Core/Util/String";
import { FormattedDate } from "DataProviders/IMyWorkProvider";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { ago } from "VSSUI/Utilities/Date";
import { activityDateFieldName } from "Work/Views/MyWork/DataProviders/MyWorkProviderBase";

const AssignedToMeDataProviderId = "ms.vss-work-web.suite-home-mywork-data-provider";

/**
 * Data provider to retrieve data for the 'Assigned To Me' section.
 */
export class MyWorkAssignedToMeDataProvider {
    private _displayItems: WorkItem[] = [];
    private _pageContext: IVssPageContext;
    private _contributionService: IVssContributionService;
    private _data: AccountMyWorkResult | undefined;

    constructor(pageContext: IVssPageContext) {
        this._pageContext = pageContext;
        this._contributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
        this._data = this._contributionService.getData<AccountMyWorkResult>(AssignedToMeDataProviderId);
    }

    public getWorkItems(): WorkItem[] {
        if (!this._data) {
            return [];
        }

        const workItems: AccountWorkWorkItemModel[] = this._data.workItemDetails;
        this._displayItems = workItems
            .filter(item => item.state !== "Removed")
            .map(item => {
                const projectName = item.teamProject;
                const id = item.id;
                const workItemEditUrl = projectName
                    ? routeUrl(this._pageContext, ContributionRoutes.WorkItemRoute, {
                          project: projectName,
                          id: `${id}`
                      })
                    : "";
                const projectUrl = projectName ? routeUrl(this._pageContext, ContributionRoutes.ProjectRoute, { project: projectName }) : "";
                const customChangedDate = format(MyWorkResources.LastUpdatedDateFormat, ago(item.changedDate));
                const formattedDate: FormattedDate = {
                    date: item.changedDate,
                    formattedDate: customChangedDate
                };

                return ({
                    fields: {
                        [CoreFieldRefNames.AssignedTo]: item.assignedTo,
                        [CoreFieldRefNames.State]: item.state,
                        [CoreFieldRefNames.TeamProject]: item.teamProject,
                        [CoreFieldRefNames.Title]: item.title,
                        [CoreFieldRefNames.WorkItemType]: item.workItemType,
                        [activityDateFieldName]: formattedDate
                    },
                    id: id,
                    _links: {
                        html: workItemEditUrl,
                        project: projectUrl
                    }
                } as unknown) as WorkItem;
            });

        return this._displayItems;
    }

    public getLimitExceeded(): boolean {
        return this._data ? this._data.querySizeLimitExceeded : false;
    }

    public getWorkItemCount(): number {
        return this._displayItems.length;
    }
}
